import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { HomeComponent } from './components/home/home.component';
import { AboutComponent } from './components/about/about.component';
import { CoreRoutingModule } from './core.routing';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { ContactComponent } from './components/contact/contact.component';
import { FullLoginComponent } from './components/full-login/full-login.component';
import { FullRegisterComponent } from './components/full-register/full-register.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { SendConfirmComponent } from './components/send-confirm/send-confirm.component';

const COMPONENTS = [
  FooterComponent,
  HeaderComponent,
  HomeComponent,
  AboutComponent,
  NotFoundComponent,
  ContactComponent,
  FullLoginComponent,
  FullRegisterComponent,
  ForgotPasswordComponent,
  SendConfirmComponent
];

@NgModule({
  declarations: COMPONENTS,
  imports: [CommonModule, CoreRoutingModule, FormsModule, ReactiveFormsModule],
  exports: COMPONENTS
})
export class CoreModule {
  static forRoot() {
    return {
      ngModule: CoreModule,
      providers: []
    };
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/core/core.module.ts